import React from 'react'

import { TimeLineEvent, TimelineSpanParent } from '../../domain/TimelineSpan'
import { TraceSpanCategory } from '../../domain/Trace'
import Milliseconds from '../../helper/milliseconds'
import Shorten from '../../helper/shorten'
import { BoxTitle } from '../../ui/box'
import Memory from '../../helper/memory'
import { ParentSpansList } from '../tracedetails/ParentSpansList'

interface Props {
    event: TimeLineEvent
    categories: { [category: string]: TraceSpanCategory }
    parents?: TimelineSpanParent[]
    route?: string
}
class Event extends React.Component<Props> {
    public static defaultProps = {
        parents: [],
    }

    public render() {
        if (!this.props.event) {
            return null
        }

        const { event, parents } = this.props

        const category = event.cat in this.props.categories ? this.props.categories[event.cat] : { className: 'php', label: 'Function' }

        return (
            <>
                <div className="box-header">
                    <BoxTitle className="tw-mt-0" muted>
                        Event
                    </BoxTitle>
                </div>
                <div className="box-header">
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                        <div className={'category category-' + category.className}>{category.label || 'Event'}</div>
                        <h4 className="box-title">
                            <Shorten string={event.name} />
                        </h4>
                    </div>
                </div>
                <div className="box-body">
                    <div className="row">
                        <div className="col-md-6">
                            <small>Started at</small>
                            <br />
                            <Milliseconds value={+event.cs} />
                        </div>
                        <div className="col-md-6">
                            <small>Duration</small>
                            <br />
                            <Milliseconds value={+event.wt} />
                        </div>
                    </div>
                    {event.ms && event.mc && event.mc > 0 ? (
                        <div className="row">
                            <div className="col-md-6">
                                <small>Memory Start</small>
                                <br />
                                <Memory value={+event.ms} />
                            </div>
                            <div className="col-md-6">
                                <small>Memory Change</small>
                                <br />
                                <Memory value={+event.mc} />
                            </div>
                        </div>
                    ) : null}
                    {this.props.route ? (
                        <ParentSpansList parents={parents || []} categories={this.props.categories} route={this.props.route} />
                    ) : null}
                </div>
            </>
        )
    }
}

export default Event
